module.exports = __webpack_public_path__ + "static/img/4.73f34744.png";